import { forwardRef, HTMLAttributes, memo } from "react";
import classnames from "classnames";
import { FileDefault } from "./FileDefault";
import { FileGray } from "./FileGray";
import { FileSolid } from "./FileSolid";
import { SimpleIcon } from "./icons";

import styles from "./style.module.scss";

export type FileType = "default" | "gray" | "solid"
export type IconType = "fileType" | "simple"

export type FileTypeIconProps = HTMLAttributes<HTMLDivElement> & {
  fileType?: FileType
  mimeType?: string
  iconType?: IconType
  isFolder?: boolean
  errorFile?: boolean
  videoIconType?: string
  fileExtension?: string
};

export const FileTypeIcon = memo(forwardRef<HTMLDivElement, FileTypeIconProps>((
  {
    isFolder,
    errorFile,
    iconType,
    fileType,
    mimeType,
    className,
    videoIconType,
    fileExtension,
    ...props
  },
  ref,
) => {
  const getFileIcon = () => {
    switch (fileType) {
      case "default":
        return <FileDefault fileExtension={fileExtension} mimeType={mimeType} isFolder={isFolder} videoIconType={videoIconType} />;
      case "gray":
        return <FileGray fileExtension={fileExtension} mimeType={mimeType} isFolder={isFolder} videoIconType={videoIconType} />;
      case "solid":
        return <FileSolid fileExtension={fileExtension} mimeType={mimeType} isFolder={isFolder} videoIconType={videoIconType} />;
    }
  };

  return (
    <div
      className={classnames(className, styles.root)}
      ref={ref}
      {...props}
    >
      {iconType === "simple" ? (
        <div className={classnames(styles.iconBox, {
          [styles.iconError]: errorFile,
        })}>
          <SimpleIcon />
        </div>
      ) : getFileIcon()}
    </div>
  );
}));
